import script from "./UserDescriptionEditor.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserDescriptionEditor.vue?vue&type=script&setup=true&lang=ts"

import "./UserDescriptionEditor.vue?vue&type=style&index=0&id=2cdc41e8&lang=scss"

const __exports__ = script;

export default __exports__